<script>
  import { blurOnClick } from '../../../../../../../js/blurOnClick';
  import { trackLinkClick } from '../../../../../../../js/trackLinkClick';

  export let id;
  export let title;
  export let url;
  export let isSelected = false;
</script>

<a
  {id}
  href={url}
  class:isSelected
  class="CtaSubnavMobileNavLink"
  use:blurOnClick
  use:trackLinkClick={{ id, title, url }}
>
  <span>{title}</span>
</a>

<style>@charset "UTF-8";
.CtaSubnavMobileNavLink {
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  display: block;
  position: relative;
  width: 100%;
  margin: 0;
  padding: 0;
  outline: 0;
  border: 0;
  color: var(--color-text, #1a1a1a);
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  letter-spacing: normal;
  text-align: left;
  text-decoration: none;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
  padding: 10px 25px;
  color: var(--color-gray, #737373);
  font-weight: var(--font-weight-medium, 500);
}
.CtaSubnavMobileNavLink::-moz-focus-inner {
  border: 0;
}
.CtaSubnavMobileNavLink:focus {
  outline: none;
}
.CtaSubnavMobileNavLink::before {
  content: "";
  pointer-events: none;
  display: block;
  position: absolute;
  inset: 0;
  background-color: var(--color-highlight, rgba(26, 26, 26, 0.1));
  border-radius: 0;
  opacity: 0;
  transition: opacity 100ms cubic-bezier(0.4, 0, 0.2, 1), transform 100ms cubic-bezier(0.4, 0, 0.2, 1);
  transform: scale(0);
}
.CtaSubnavMobileNavLink:focus:not(:active)::before {
  opacity: 1;
  transform: scale(1);
}
.CtaSubnavMobileNavLink > * {
  position: relative;
}
.CtaSubnavMobileNavLink:hover {
  color: var(--color-text, #1a1a1a);
}

.isSelected {
  color: var(--color-text, #1a1a1a);
}</style>
